import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Overview from './components/Overview';
import Services from './components/Services';
import Portfolio from './components/Portfolio';
import WhyUs from './components/WhyUs';
import Team from './components/Team';
import SocialFeed from './components/SocialFeed';
import Contact from './components/Contact';
import LoadingScreen from './components/LoadingScreen';
import { Toaster } from './components/ui/toaster';

function Home() {
  return (
    <div className="App">
      <LoadingScreen />
      <Header />
      <main>
        <Hero />
        <Overview />
        <Services />
        <Portfolio />
        <WhyUs />
        <Team />
        <SocialFeed />
        <Contact />
      </main>
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
